
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.599 9.402c0-.387-.123-.706-.37-.957-.246-.255-.656-.483-1.23-.683-.574-.205-1.02-.394-1.34-.568-1.062-.57-1.593-1.412-1.593-2.529 0-.756.23-1.379.69-1.866.461-.488 1.085-.777 1.874-.868V.44h1.094v1.503c.793.114 1.406.452 1.838 1.012.433.556.65 1.28.65 2.174H5.558c0-.574-.13-1.026-.39-1.354-.255-.332-.604-.499-1.046-.499-.437 0-.78.119-1.025.356-.246.237-.37.576-.37 1.018 0 .397.121.716.363.957.246.237.66.463 1.244.677.583.214 1.041.413 1.374.595.333.182.613.392.84.629.229.232.404.501.527.806.123.306.185.664.185 1.074 0 .77-.237 1.394-.711 1.873-.47.478-1.126.76-1.969.847v1.333H3.493v-1.326c-.902-.1-1.597-.424-2.085-.97-.483-.547-.724-1.272-.724-2.174h1.66c0 .574.144 1.018.431 1.333.292.314.702.471 1.23.471.52 0 .915-.125 1.183-.376.274-.25.41-.583.41-.998z","fill":"#8F7A61"}})])
          )
        }
      }
    